// this code below is only to clear cart token and cache 
(function () {
  const FLAG = 'shopify_state_reset_v1';

  if (sessionStorage.getItem(FLAG)) return;

  sessionStorage.setItem(FLAG, '1');

  try {
    // Clear Shopify-related localStorage
    const keysToClear = [
      'cart',
      'cart_token',
      'shopify_recently_viewed',
      'currency',
      'shipping',
      'shopify_pay_redirect'
    ];

    keysToClear.forEach(k => {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    });

    // Clear cookies (best effort only)
    document.cookie.split(';').forEach(cookie => {
      document.cookie = cookie
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
    });

  } catch (e) {}

  // Force clean reload once
  location.reload();
})();
// code ends here 


window.Currency = (function() {

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    // var formatString = format || moneyFormat;
    var formatString = format;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    if(formatString) {
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
      
    }

  }

  return {
    formatMoney: formatMoney
  };
})();

function getBannerEl() {
  return document.getElementById('cookies-banner');
}

function hideBanner(res) {
  getBannerEl().style.display = 'none';
}

function showBanner() {
 getBannerEl().style.display = 'block';
}

function handleAccept(e) {
  window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

  document.addEventListener('trackingConsentAccepted',function() {
    console.log('trackingConsentAccepted event fired');
  });
}

function handleDecline() {
  window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
}

function initCookieBanner() {
  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
  const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
  console.log(userCanBeTracked);
  if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
    showBanner();
  }
}

window.Shopify.loadFeatures([
  {
    name: 'consent-tracking-api',
    version: '0.1',
  },
],
function(error) {
  if (error) {
    throw error;
  }

  initCookieBanner();
  });


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    if (this.select) { 
      this.select.addEventListener('change', this.onSelectChange.bind(this));
    }
    if (this.input) {
      this.maxValue = this.input.max;
      this.minValue = this.input.min;
      this.disableButtons();
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
    
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }
    this.changeEvent = new Event('change', { bubbles: true })
    
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );


  }

  onChange(event) {
    this.disableButtons();
  }

  onSelectChange() {
    const selectValue = this.select.options[this.select.selectedIndex].value;
    this.input.value = selectValue;
  }

  

  disableButtons(event) {

    this.currentValue = this.input.value;

    if (this.maxValue == this.currentValue) {
      this.querySelector('[name="plus"]').disabled = true;
    } else {
      this.querySelector('[name="plus"]').disabled = false;
    }

    if (this.minValue == this.currentValue) {
      this.querySelector('[name="minus"]').disabled = true;
    } else {
      this.querySelector('[name="minus"]').disabled = false;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.setVar('loadPage')
  }

  setVar(when) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.usps = this.header.querySelector('.usp-bar');
    if (this.usps) {
      this.uspOffset = this.usps.offsetHeight;
    } else {
      this.uspOffset = 0;
    }
    var headerPosition = '0';
    if (when == 'loadPage') {
      headerPosition = this.header.offsetHeight + this.uspOffset; 
    } else {
      headerPosition = this.header.getBoundingClientRect().bottom;
    }
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerPosition - this.borderOffset - this.uspOffset)}px`);
  }

  openMenuDrawer(summaryElement) {
    this.setVar('openMenu');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul.slider');
    this.sliderItems = this.querySelectorAll('ul.slider > li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.thumbnailButton = this.querySelectorAll('button[name="thumbnail]');
    this.thumbnailWrap = this.querySelector('.slider-thumbnails ol');
    this.dotButton = this.querySelectorAll('button[name="dot]');
    this.dotWrap = this.querySelector('.slider-dots ol');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.thumbnailWrap) {
      this.thumbnailWrap.addEventListener('click', this.onThumbnailClick.bind(this));
    }
    if (this.dotWrap) {
      this.dotWrap.addEventListener('click', this.onDotClick.bind(this));
    }
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.round(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.resize();
  }

  resize() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderCurrentItem = sliderItemsToShow[this.currentPage - 1];
    this.thumbnailHeight = this.thumbnailWrap.offsetHeight;
    this.currentHeight = this.sliderCurrentItem.offsetHeight + this.thumbnailHeight;
    if (this.slidesPerPage === 1) {
        this.style.height = this.currentHeight + 'px';
    } else {
      this.style.minHeight = this.currentHeight + 'px';
    }
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    var previousPage = this.pageCount.textContent;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.pageCount.textContent != this.currentPage) {
      this.resize();
    }
      
    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
    if (previousPage != this.currentPage) {
      this.setActiveSlide();
    }

    
  }

  setActiveSlide(event) {
    this.activeSlide = this.currentPage - 1;
    this.sliderItems.forEach(slide => {
      slide.classList.remove('active');
    });
    this.sliderItems[this.activeSlide].classList.add('active');
    if (this.dotWrap) {
      const dots = this.dotWrap.querySelectorAll('li');

      dots.forEach(dot => {
        dot.classList.remove('active');
      });
      dots[this.activeSlide].classList.add('active');
    }
    this.currentSlideElem = this.sliderItems[this.activeSlide];
    if (this.currentSlideElem.classList.contains('product__media-item--video')){
      this.playVideo();
    } else {
      window.pauseAllMedia();
    };

  }

  playVideo() {
    console.log('play');
    this.deferredMedia = this.currentSlideElem.querySelector('deferred-media');
    this.deferredMedia.loadContent();
    var videoElem = this.currentSlideElem.querySelector('video');
    if(videoElem) videoElem.play();

  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onDotClick(event) {
    event.preventDefault();
    var HAS_COMPUTED_STYLE = !!window.getComputedStyle;
    var getStyles = window.getComputedStyle || function () { };
    var isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    var getFloat = function(value) {
      value = parseFloat(value);
      return isNumber(value) ? value : 0
    };
    const slideToShow = event.target.dataset.dot;
    if (!HAS_COMPUTED_STYLE) {
      var slideWidth = this.sliderItems[0].clientWidth; 
    } else {
      var slideWidth = getFloat(window.getComputedStyle(this.sliderItems[0]).width);
    }
    const slideScrollPosition = slideWidth * (slideToShow -1);
    //const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onThumbnailClick(event) {
    event.preventDefault();
    var HAS_COMPUTED_STYLE = !!window.getComputedStyle;
    var getStyles = window.getComputedStyle || function () { };
    var isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    var getFloat = function(value) {
      value = parseFloat(value);
      return isNumber(value) ? value : 0
    };
    const slideToShow = event.target.dataset.thumbnail;
    if (!HAS_COMPUTED_STYLE) {
      var slideWidth = this.sliderItems[0].clientWidth; 
    } else {
      var slideWidth = getFloat(window.getComputedStyle(this.sliderItems[0]).width);
    }
    const slideScrollPosition = slideWidth * (slideToShow -1);
    //const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const mediaContainer = document.querySelector("div[is='product-media-lightbox']");
        const productmedia = html.querySelector("div[is='product-media-lightbox']");
        if (mediaContainer) mediaContainer.outerHTML = productmedia.outerHTML;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.text');
    const addButtonPrice = productForm.querySelector('[name="add"] > span.button--cta-price');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
      if (addButtonPrice) addButtonPrice.classList.add('hidden');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (addButtonPrice) addButtonPrice.classList.remove('hidden');
      if (addButtonPrice) addButtonPrice.textContent = window.Currency.formatMoney(this.currentVariant.price, window.currency.currencyFormat); 

    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      console.log(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CartAddButton extends HTMLElement {
  constructor() {
    super();
    this.cartNotification = document.querySelector('cart-notification');
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.addProduct(this.dataset.id, 1);
      } else {
        this.addProduct(this.dataset.id, 1);
      }
    });
  }
  addProduct(id, quantity, line) {
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');
    //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      this.cartNotification.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.classList.remove('loading');
      this.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      const lineItem =  document.getElementById(`CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

    });
  }
}
customElements.define('cart-add-button', CartAddButton);

var mql = window.matchMedia("only screen and (max-width: 768px)");

mediaqueryresponse(mql);
mql.addEventListener('change', mediaqueryresponse);

function mediaqueryresponse(mql) {
    if (mql.matches) { // Mobile JS
      uspSlider();
      toggleFooterLinks();
    }
}

function uspSlider() {
  const announcementBar = document.querySelector('#shopify-section-header .usp-bar');
  if (matchMedia("only screen and (max-width: 768px)").matches) {
    if (announcementBar) {
          var items = announcementBar.querySelectorAll('.usp-bar__item');
          var i = 0;
          len = items.length;
          items[0].classList.add('active');
          var alternating = setInterval(function () {
            items.forEach(item => {
              
                  item.classList.remove('active');
              });
              items[i].classList.add('active');
              i = (i + 1) % len;
          }, 5000)
      }
  }
}

function toggleFooterLinks() {

  const expandButtons = document.querySelectorAll('.mobile-expand');
  expandButtons.forEach(button => {
    var closed = true;
    button.addEventListener('click', function (e) { 
      e.preventDefault();
      if (closed) {
        button.classList.add('animate', 'active');
        closed = false;
      } else {
        button.classList.remove('animate', 'active');
        closed = true;

      }
    });
  });

}

function expandFooterLinks() {
  const expandButtons = document.querySelectorAll('.mobile-expand');
  expandButtons.forEach(button => {
    button.classList.remove('animate', 'active');
    closed = true;
  });
}

class QuantitySelect extends HTMLElement {
  constructor() {
    super();
    this.buttonPrice = this.closest('.product').querySelector('.button--cta-price');
  }


  connectedCallback() {
    this.quantityInput = this.closest('.product').querySelector('[name="quantity"]');
    this.init();
    console.log('test');
  }

  init() {
    this.addEventListener('click', (event) => {
      console.log(event);
      if (event.target.closest('.quantity-picker__item')) { 
        event.preventDefault();
        this.updateQuantity(event);
    }
    });


  }

  updateButtonPrice() {
    if (!this.buttonPrice) return;
    const selected = this.querySelector('.quantity-picker__item.selected');
    if (selected) {
      this.buttonPrice.innerText = selected.querySelector('.price-item').innerText;
    }
  }


  updateQuantity(event) {
    const quantity = event.target.closest('.quantity-picker__item').getAttribute('data-quantity');
    this.querySelectorAll('.quantity-picker__item').forEach(row => row.classList.remove('selected'));
    event.target.closest('.quantity-picker__item').classList.add('selected');
    this.quantityInput.value = quantity;
    this.updateButtonPrice();
    // bubble the event up to the form
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true })); 
  }

}

customElements.define('quantity-select', QuantitySelect);

// class CartShippingCosts extends HTMLElement {
//   constructor() {
//     super();
//     this.shippingCostElem = this.querySelector('[data-shipping-costs]');
//     this.totalPriceElem = this.querySelector('[data-price]');
//     this.originalPrice = parseInt(this.totalPriceElem.dataset.price);
//     fetch(`${routes.cart_url}/prepare_shipping_rates.json?shipping_address%5Bzip%5D=${window.shipping.postal_code}&shipping_address%5Bcountry%5D=${window.shipping.country}`, {
//       method: 'POST', 
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(),
//     })
//       .then(response => response.json())
//       .then(data => {
//         return fetch(
//           `${routes.cart_url}/async_shipping_rates.json?shipping_address%5Bzip%5D=${window.shipping.postal_code}&shipping_address%5Bcountry%5D=${window.shipping.country}`,
//           {
//             method: 'GET',
//             body: JSON.stringify()
//           }
//         );
//       })
//       .then(response => response.json())
//       .then(rates => {
//         const firstShippingRate = rates.shipping_rates[0];
//         const newTotalPrice = (firstShippingRate.price * 100) + this.originalPrice;
//         if (this.shippingCostElem) {
          
//           this.shippingCostElem.innerHTML = window.Currency.formatMoney(firstShippingRate.price, window.currency.currencyFormat);
//           this.totalPriceElem.innerHTML = window.Currency.formatMoney(newTotalPrice, window.currency.currencyFormat);
//         }
  
//       });
//   }
// }

// customElements.define('cart-shipping-costs', CartShippingCosts);

document.addEventListener("DOMContentLoaded", function() {
  const parentTarget = document.querySelector('.product__buy--make-sticky');
  if(parentTarget) {
    const childTarget = parentTarget.querySelector('.product-form');
  }

  if (!parentTarget || !childTarget) {
    console.log('Required elements not found.');
    return;
  }

  // Create a placeholder to maintain layout
  const placeholder = document.createElement('div');
  placeholder.style.display = 'none'; // Initially hidden
  parentTarget.parentNode.insertBefore(placeholder, parentTarget.nextSibling);

  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      requestAnimationFrame(() => {
        if (entry.boundingClientRect.top < 0) {
          // Set CSS variable on the body for the height of the parentTarget
          const height = `${parentTarget.offsetHeight}px`;
          document.body.style.setProperty('--sticky-element-height', height);
          placeholder.style.height = height;
          placeholder.style.display = 'block';
          childTarget.classList.add('product__buy--sticky');
        } else {
          // Remove the CSS variable when not sticky
          document.body.style.removeProperty('--sticky-element-height');
          placeholder.style.display = 'none';
          childTarget.classList.remove('product__buy--sticky');
        }
      });
    });
  }, {
    threshold: 0
  });

  observer.observe(parentTarget);

  // Optional: Clean up the observer when it's no longer needed
  window.addEventListener('unload', () => observer.disconnect());
});



//-- CUSTOM JS START --//

window.addEventListener('DOMContentLoaded', ()=> {
  //-- Display quantity price on ATC button -- //
  // setInterval(()=> {
  //   const atcBtn = document.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]');
  //   if(atcBtn) {
  //     let qtyPrice = '';
  //     if(atcBtn.disabled) {
  //       const selected = document.querySelector('.product-form__input--quantities input[type=radio]:checked+label');
  //       const defaultPrice = selected
  //     }
  //   }
  // }, 1000)

  const quantitySelector = document.querySelectorAll('.product-form__input--quantities input[type=radio]');
  const ATCBtn = document.querySelector('product-form button[type="submit"]');
  const buttonPrice = document.querySelector('product-form button[type="submit"] .button--cta-price');

  const updateButtonPrice = (price) => {
    const interval = setInterval(() => {
      
      const btnStatus = ATCBtn.disabled;

      if(!btnStatus) {
        buttonPrice.innerText = price;
        clearInterval(interval);
      }
    }, 100)
  }
  
  quantitySelector.forEach(selector => {
    selector.addEventListener('change', () => {
      const label = document.querySelector('.product-form__input--quantities input[type=radio]:checked+label');
      const isOnSale = label.querySelector('.price--on-sale');
      let price = '';

      if(isOnSale) {
        price = isOnSale.querySelector('.price-item--sale').innerText;
      } else {
        price = label.querySelector('.price-item').innerText;
      }
      
      updateButtonPrice(price);
    });
  })
});

//-- CUSTOM JS END --//


class ProductMediaLightbox extends HTMLDivElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.lightbox = null;
    this.lightboxContent = null;
  }

  connectedCallback() {
    this.initSwiper();
    this.setupLightboxElements();
    if (this.lightbox && this.lightboxContent) {
      this.buildLightbox();
      this.setupEventListeners();
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper('.product_images_slider', {
      slidesPerView: 1.2,
      spaceBetween: 10,
      allowTouchMove: true
    });
  }

  setupLightboxElements() {
    this.lightbox = document.getElementById('gallery-lightbox');
    this.lightboxContent = document.getElementById('gallery-lightbox-content');
  }

  buildLightbox() {
    this.lightboxContent.innerHTML = '';
    const allMediaSlides = document.querySelectorAll('.product_images_slider .swiper-slide');

    allMediaSlides.forEach((slide, index) => {
      let galleryItem = null;

      if (slide.tagName === 'IMG') {
        galleryItem = document.createElement('img');
        galleryItem.src = slide.src;
      } else {
        const video = slide.querySelector('video');
        if (video) {
          galleryItem = document.createElement('video');
          galleryItem.src = video.querySelector('source') ? video.querySelector('source').src : video.src;
          galleryItem.controls = true;
          galleryItem.autoplay = true;
          galleryItem.muted = true;
          galleryItem.loop = true;
          galleryItem.playsInline = true;
        }
      }

      if (galleryItem) {
        galleryItem.id = `gallery-media-${index}`;
        this.lightboxContent.appendChild(galleryItem);
      }
    });
  }

  setupEventListeners() {
    const closeButton = this.lightbox.querySelector('.close');

    this.swiperInstance.on('click', (swiper) => {
      if (swiper.clickedIndex !== undefined) {
        this.openLightboxAndScrollTo(swiper.clickedIndex);
      }
    });

    const desktopGrid = document.querySelector('.product_images_custom_grid');
    if (desktopGrid) {
      const desktopMedia = desktopGrid.querySelectorAll('img, video');
      desktopMedia.forEach((mediaElement, index) => {
        mediaElement.addEventListener('click', () => {
          this.openLightboxAndScrollTo(index);
        });
      });
    }

    closeButton.addEventListener('click', () => this.closeLightbox());
    this.lightboxContent.addEventListener('click', () => this.closeLightbox());
  }

  openLightboxAndScrollTo(index) {
    this.lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';

    const targetMedia = document.getElementById(`gallery-media-${index}`);
    if (targetMedia) {
      targetMedia.scrollIntoView({ behavior: 'auto', block: 'start' });
      if (targetMedia.tagName === 'VIDEO') {
        targetMedia.play().catch(() => {});
      }
    }
  }

  closeLightbox() {
    this.lightbox.classList.remove('active');
    document.body.style.overflow = '';
    this.lightboxContent.querySelectorAll('video').forEach(video => video.pause());
  }
}

customElements.define('product-media-lightbox', ProductMediaLightbox, { extends: 'div' });